import { render } from "./CandidateDetails.vue?vue&type=template&id=7ad6ec6e&scoped=true"
import script from "./CandidateDetails.vue?vue&type=script&lang=js"
export * from "./CandidateDetails.vue?vue&type=script&lang=js"

import "./CandidateDetails.vue?vue&type=style&index=0&id=7ad6ec6e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ad6ec6e"]])

export default __exports__